import { routePrefixLanguages, languageDutch } from "../i18n";

/**
 * Returns the current language based on the pathname prefix.
 * If the first path segment matches one of the supported prefixes (e.g. 'en'),
 * that language is returned; otherwise the default language is returned.
 */
export function getLanguageFromPathname(pathname: string): string {
  const [firstSegment] = pathname.split("/").filter(Boolean);
  if (firstSegment && routePrefixLanguages.includes(firstSegment)) {
    return firstSegment;
  }
  return languageDutch;
}
